import { render, staticRenderFns } from "./TdxDropdownTriangle.vue?vue&type=template&id=5b14864b&scoped=true&"
import script from "./TdxDropdownTriangle.vue?vue&type=script&lang=ts&"
export * from "./TdxDropdownTriangle.vue?vue&type=script&lang=ts&"
import style0 from "./TdxDropdownTriangle.vue?vue&type=style&index=0&id=5b14864b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b14864b",
  null
  
)

export default component.exports